import React from 'react';
import useSEO from '../hooks/useSEO';
import Clients from '../components/Clients';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import FAQ from '../components/FAQ';
import SRVCS from '../components/SRVCS';

const Home = () => {
    useSEO({
        title: "Yaniva Ventures | Premium SME IPO Consulting & Corporate Advisory",
        description: "Expert SME IPO advisory and corporate finance solutions. Partner with Yaniva Ventures to unlock growth capital and list your enterprise."
    });

    return (
        <>
            <Hero />
            <Intro />
            <SRVCS />
            <FAQ/>
            <Clients />
        </>
    );
};

export default Home;
